
import { Vue } from "vue-class-component";
export default class ImportantFile extends Vue {}
